import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserAstronaut,
  faUserGroup,
  faHouse,
  faShip,
  faRankingStar,
  faFolderOpen,
  faBookOpen,
  faNewspaper
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';

export const CSMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/counter-side/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/counter-side/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/counter-side/operators">
        <Nav.Link as="span" eventKey="operators" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserAstronaut} width="18" />{' '}
          <span>Operators</span>
        </Nav.Link>
      </Link>
      <Link to="/counter-side/ships">
        <Nav.Link as="span" eventKey="ships" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faShip} width="18" /> <span>Ships</span>
        </Nav.Link>
      </Link>
      <Link to="/counter-side/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/counter-side/database/">
        <Nav.Link as="span" eventKey="database" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faFolderOpen} width="18" />{' '}
          <span>Database</span>
        </Nav.Link>
      </Link>
      <Link to="/counter-side/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/counter-side/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
